import { render, staticRenderFns } from "./ChainSelect.vue?vue&type=template&id=5cc2c934"
import script from "./ChainSelect.vue?vue&type=script&lang=ts"
export * from "./ChainSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports